import { render, staticRenderFns } from "./coordinate-add-or-update.vue?vue&type=template&id=08534e9e&scoped=true"
import script from "./coordinate-add-or-update.vue?vue&type=script&lang=js"
export * from "./coordinate-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./coordinate-add-or-update.vue?vue&type=style&index=0&id=08534e9e&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08534e9e",
  null
  
)

export default component.exports